//import anchorClickHandler from '../../../assets/scripts/modules/anchor-click-handler.js'
import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

//const randomInt = (min = 0, max = 1) => Math.floor(Math.random() * (max - min + 1) + min)

const MAX_POSITIONS = 6

class LandingChaptersComponent extends Component {
  init() {
    //this.preTitle = this.element.getAttribute('data-pre-title') || ''
    this.objectIndex = 0

    window.addEventListener('micrio-data', event => this.initAfterData(event?.detail?.chapters?.items || []))
  }

  initAfterData(chapters = []) {
    const template = this.element.querySelector('.landing-chapters__template')

    chapters = chapters.filter(({ title, objects }) => title && objects)

    if (!template || !chapters.length) {
      return
    }

    chapters.forEach(({ title, href, color, objects }, index) => this.createChapter(template, title, href, color, objects, index))
  }

  createChapter(template, title, href, color, objects, index) {
    const wrapper = this.element.querySelector('.landing-chapters__wrapper')

    if (!template || !title || !wrapper) {
      return
    }

    const clone = template.content.cloneNode(true)

    const chapter = clone.querySelector('.landing-chapters__chapter')
    chapter?.classList.add(`landing-chapters__chapter--${color || 'orange'}`)

    //const elementPreTitle = chapter.querySelector('.landing-chapters__chapter-pre-title')
    const elementTitle = chapter.querySelector('.landing-chapters__chapter-title')

    this.preTitle = this.preTitle ? `${this.preTitle} ${index + 1}` : ''
    //this.preTitle ? (elementPreTitle.textContent = this.preTitle) : elementPreTitle.remove()
    title ? (elementTitle.textContent = title) : elementTitle.remove()
    objects = objects.filter(object => object.imageSrc && object.linkHref && object.title)
    objects.length ? this.createObjects(clone, objects) : chapter.querySelector('.landing-chapters__chapter-objects').remove()

    wrapper.appendChild(clone)

    const cursor = chapter.querySelector('.cursor')
    const hitTarget = chapter.querySelector('.hit-target')

    if (cursor && href) {
      cursor.href = href
    }

    if (hitTarget && href) {
      hitTarget.href = href
    }

    this.initChapterScrollTween(chapter)

    chapter.classList.add('landing-chapters__chapter--visible')
  }

  initChapterScrollTween(chapter) {
    if (!chapter) {
      return
    }

    window.GSAP.set(chapter, { force3D: true })

    const colorMatch = chapter.className.match(/landing-chapters__chapter--(\w+)/)
    const color = colorMatch ? colorMatch[1] : 'orange'

    window.ScrollTrigger.create({
      trigger: chapter,
      start: 'top top-=15%',
      end: 'bottom top',
      onUpdate: self => {
        chapter.style.filter = `blur(${-20 - +(20 / 100) * (self.progress * 100)}px`
        chapter.style.setProperty('--color-foreground', self.progress === 0 ? '' : 'var(--color-black)')
        chapter.style.pointerEvents = self.progress === 0 ? 'unset' : 'none'

        if (color && self.direction === -1 && self.progress === 0) {
          document.querySelector('.container--wrapper')?.style.setProperty('--color-foreground', `var(--color-${color}-light)`)
        }
      },
    })
    window.ScrollTrigger.create({
      trigger: chapter,
      start: 'top bottom',
      end: 'bottom bottom+=15%',
      onUpdate: self => {
        chapter.style.filter = `blur(${20 + -((20 / 100) * (self.progress * 100))}px`
        chapter.style.setProperty('--color-foreground', self.progress === 1 ? '' : 'var(--color-black)')
        chapter.style.pointerEvents = self.progress === 1 ? 'unset' : 'none'

        if (color && self.direction === 1 && self.progress === 1) {
          document.querySelector('.container--wrapper')?.style.setProperty('--color-foreground', `var(--color-${color}-light)`)
        }
      },
    })
  }

  createObjects(clone, objects) {
    if (!clone || !objects.length) {
      return
    }

    const chapter = clone.querySelector('.landing-chapters__chapter')
    const elementObjects = chapter.querySelector('.landing-chapters__chapter-objects')
    const template = this.element.querySelector('.landing-chapters__object-template')

    if (!chapter || !elementObjects || !template) {
      return
    }

    objects = objects.filter(object => object.title && object.linkHref && object.imageSrc)

    // TODO: REMOVE TEMP
    /*
    if (objects.length === 2) {
      objects[3] = objects[0]
      objects[4] = objects[1]
      objects[5] = objects[0]
      objects[6] = objects[1]
      objects[7] = objects[0]
      objects[8] = objects[1]
    }
    */

    objects.forEach(({ title, linkHref, imageSrc }) => {
      const clone2 = template.content.cloneNode(true)

      const elementLink = clone2.querySelector('.image-stamp')
      const elementImage = clone2.querySelector('.image-stamp__image')

      elementLink.href = linkHref
      elementImage.src = imageSrc
      elementImage.alt = title || ''

      const position = (this.objectIndex++ % MAX_POSITIONS) + 1
      elementLink.classList.add(`image-stamp--position-${position}`)

      elementLink.appendChild(elementImage)
      //elementLink.classList.add('prevent-handler')
      //elementLink.addEventListener('click', event => this.openObjectWithZoom(event, elementLink))

      clone2.appendChild(elementLink)

      elementObjects.appendChild(clone2)

      this.initObjectScrollTween(elementLink, position, chapter)
    })
  }

  initObjectScrollTween(object, position, chapter) {
    if (!object || !position) {
      return
    }

    window.GSAP.set(object, { force3D: true })

    window.ScrollTrigger.create({
      trigger: chapter,
      start: 'top bottom',
      end: 'bottom top',
      onUpdate: self => {
        const boundaries = [
          [250, -250],
          [150, -150],
          [50, -50],
          [225, -225],
          [125, -125],
          [25, -25],
          [175, -175],
          [75, -75],
        ]

        const min = boundaries[position - 1] ? boundaries[position - 1][0] : 0
        const max = -min + (boundaries[position - 1] ? boundaries[position - 1][1] : 0)

        //console.log(min, max, self.progress, position)

        object.style.transform = `translateY(${min + (max / 100) * (self.progress * 100)}%)`
      },
    })
  }

  resetCursor(cursor) {
    if (!cursor) {
      return
    }

    cursor.classList.add('cursor--visible')
    cursor.style.position = 'relative'
    cursor.style.top = 'unset'
    cursor.style.left = 'unset'
    cursor.style.transform = 'unset'
  }

  handleIntersect(entries = []) {
    for (const entry of entries) {
      const { isIntersecting, intersectionRatio, target } = entry

      if (!isIntersecting || intersectionRatio < 0.5) {
        continue
      }

      if (target.classList.contains('landing-about') || target.classList.contains('landing-intro')) {
        document.querySelector('.container--wrapper')?.style.setProperty('--color-foreground', `var(--color-orange-light)`)
        break
      }

      target.setAttribute('data-i', intersectionRatio)

      const style = window.getComputedStyle(target)

      if (style.filter === 'none') {
        const className = target.className
        const colorMatch = className.match(/landing-chapters__chapter--(\w+)/)

        if (colorMatch) {
          document.querySelector('.container--wrapper')?.style.setProperty('--color-foreground', `var(--color-${colorMatch[1] || 'orange'}-light)`)

          break
        }
      }
    }
  }

  /*
  openObjectWithZoom(event, link) {
    if (!link) {
      return
    }

    event?.preventDefault()

    window.GSAP.to(link, {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      duration: 2,
      ease: 'power2.out',
      onComplete: () => {
        link.classList.remove('prevent-handler')
        anchorClickHandler(link.href, event)
        link.classList.add('prevent-handler')

        window.GSAP.to(link, {
          position: 'relative',
          top: 'unset',
          left: 'unset',
          width: 'unset',
          height: 'unset',
          duration: 2,
          scale: 1,
          ease: 'power2.in',
        })
      },
    })
  }
    */
}

window.addEventListener('init-load', () => loadComponent(document, 'landing-chapters', LandingChaptersComponent))
